import React from 'react';
import PropTypes from 'prop-types';
import { dynamicAssets } from '../../utilities/helpers';

const CurrencyIcon = ({ currencyCode, className = '', style = null }) => {
  const imgSrc = dynamicAssets(`./assets/icons/${currencyCode?.toUpperCase()}.svg`);
  return (
    <img
      src={typeof imgSrc === 'string' ? imgSrc : ''}
      className={className}
      style={style}
      alt={currencyCode}
    />
  );
};

export default CurrencyIcon;

CurrencyIcon.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object]),
};
